import { render, staticRenderFns } from "./SPUPreview.vue?vue&type=template&id=ea197320&scoped=true"
import script from "./SPUPreview.vue?vue&type=script&lang=ts"
export * from "./SPUPreview.vue?vue&type=script&lang=ts"
import style0 from "./SPUPreview.vue?vue&type=style&index=0&id=ea197320&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea197320",
  null
  
)

export default component.exports